import { observer } from 'mobx-react'
import type { VehicleRUL as VehicleRULType } from 'models/Vehicles/VehicleRULModel'
import { Row } from '../Table/Table'
import { BodyText } from '../Typography/Typography'

interface VehicleRULProps {
    vehicleRUL: VehicleRULType
}

export const VehicleRUL = observer(({ vehicleRUL }: VehicleRULProps) => (
    <Row>
        <BodyText>RUL:   &nbsp;&nbsp;
            {vehicleRUL.remainingDays ?? "∞"} Days   &nbsp;&nbsp;| &nbsp;&nbsp;
            {vehicleRUL.remainingFlights ?? "∞"} Flights   &nbsp;&nbsp;| &nbsp;&nbsp;
            {vehicleRUL.remainingFlightHours ?? "∞"} Flight Hours
        </BodyText>
    </Row>
))
